var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_188341610493374503651191355282467394771",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_220117895969059498171896172679978508103",
    d: "M13.659 0c7.543 0 13.658 6.115 13.658 13.659 0 7.543-6.115 13.658-13.658 13.658C6.115 27.317 0 21.202 0 13.66 0 6.115 6.115 0 13.659 0zm0 .78C6.546.78.78 6.546.78 13.66c0 7.112 5.766 12.878 12.879 12.878 7.112 0 12.878-5.766 12.878-12.878C26.537 6.546 20.77.78 13.659.78zm0 5.074c4.31 0 7.804 3.494 7.804 7.805 0 4.31-3.494 7.804-7.804 7.804-4.311 0-7.805-3.494-7.805-7.804 0-4.311 3.494-7.805 7.805-7.805zm0 15.61c4.31 0 7.804-3.495 7.804-7.805 0-4.311-3.494-7.805-7.804-7.805-4.311 0-7.805 3.494-7.805 7.805 0 4.31 3.494 7.804 7.805 7.804zm-.705-7.667c0 .868-.146 1.624-.437 2.268-.292.644-.705 1.136-1.24 1.474-.534.338-1.156.508-1.865.508-.695 0-1.311-.17-1.85-.51-.538-.34-.955-.828-1.252-1.461-.297-.634-.45-1.366-.456-2.198v-.637c0-.85.146-1.6.44-2.251.293-.652.71-1.15 1.25-1.496.54-.346 1.159-.518 1.857-.518.706 0 1.328.17 1.868.513.54.342.956.837 1.248 1.487.291.65.437 1.405.437 2.265v.556zm-1.161-.567c0-1.047-.21-1.85-.629-2.41-.42-.56-1.007-.84-1.763-.84-.738 0-1.318.28-1.741.84-.423.56-.64 1.336-.65 2.33v.647c0 1.015.212 1.813.639 2.392.427.58 1.014.87 1.763.87.752 0 1.334-.274 1.747-.821.412-.547.623-1.332.634-2.354v-.654zm5.146.594l-1.08 1.118v2.986h-1.161V9.1h1.16v4.363L19.785 9.1h1.41l-3.478 3.898 3.747 4.93H20.07l-3.131-4.104z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-164 -377) translate(98 312) matrix(1 0 0 -1 66 97) translate(2.341 1.341)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_144032916134390813989908165106722682056",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_220117895969059498171896172679978508103"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_220117895969059498171896172679978508103"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#hinava_random_uuid_188341610493374503651191355282467394771)",
    mask: "url(#hinava_random_uuid_144032916134390813989908165106722682056)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.902,
    height: 32,
    rx: 8,
    transform: "translate(-20.293 -2.341)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.44380eb56df4594eb500648e4a586f13.svg";
export { ForwardRef as ReactComponent };